import lang from './ReferralFriendsPage.lang';

export const REWARD_TAB_TYPE = {
  REFERRAL_REWARD: 1,
  RECOMMENDED_CASHBACK: 2,
  CASHBACK_FROM_TRANSACTIONS: 3,
  INVITEE_REWARD: 4,
};

export function REWARD_STATUS(LG) {
  return {
    0: LG(lang.UnderReview),
    1: LG(lang.issued),
    2: LG(lang.FailedToIssue),
  };
}

export function TRANSACTION_CASHBACK_RULES() {
  return [
    {tradingVolume: '5,000', airdropForReferrer: '1', airdropForInvitee: '0.5'},
    {tradingVolume: '10,000', airdropForReferrer: '1', airdropForInvitee: '0.5'},
    {tradingVolume: '50,000', airdropForReferrer: '3', airdropForInvitee: '1'},
    {tradingVolume: '100,000', airdropForReferrer: '5', airdropForInvitee: '1'},
  ];
}

export const REFERRAL_PAGE_ZIE = 10;

export const CHANNEL = 'WEB';

export const SCENE = 'REFERRAL';

export const MONTH_TYPES = {
  CURRENT: 'current',
  ALL: 'all',
};
